import React, { Component } from 'react';
import { Button } from 'reactstrap';

export default class NavNextBack extends Component {
    constructor(props) {
        super(props)

        this.state = {

        };
    }

    render() {
        return (
            <div className={this.props.className}>
                {this.props.back && !this.props.unsavedChanges &&
                    <div className="col-3">
                        <Button
                            color="primary"
                            id={this.props.id}
                            className="w-100"                            
                            onClick={this.props.onClickBack}
                        >
                            Back
                        </Button>
                    </div>
                }
                {this.props.next && !this.props.unsavedChanges &&
                    <div className="col-3">
                        <Button 
                            form={this.props.form}
                            type="submit"
                            id={this.props.id}
                            className="w-100"
                            color="primary"
                        >
                            Next
                        </Button>
                    </div>
                }
                {this.props.back && this.props.unsavedChanges &&
                    <div className="col-3">
                        <Button
                            id={this.props.id}
                            className="w-100"
                            color="danger"
                            onClick={this.props.onSaveChanges}
                        >
                            Save
                        </Button>
                    </div>
                }
                {this.props.next && this.props.unsavedChanges &&
                    <div className="col-3">
                        <Button
                            id={this.props.id}
                            className="w-100"
                            color="danger"
                            onClick={this.props.onSaveChanges}
                        >
                            Save
                        </Button>
                    </div>
                }
                {this.props.back && !this.props.next && !this.props.editMode &&
                    <div className="col-3">
                        <Button
                            form={this.props.form}
                            type="submit"
                            id={this.props.id}
                            className="nav-item nav-link w-100"
                            style={{ backgroundColor: "blue" }}
                        >
                            Save Profile
                        </Button>
                    </div>
                }
            </div>
        )
    }
}